// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3wrJy","footer":"ModalInfo_footer__-cj2p"};